import { FC } from 'react';
import { PieChartExtended } from '@/components/PieChart';
import { useGetFundDetailsData } from '../../../../hooks/useGetFundDetailsData';
import { useFundCompositionPieChartHandler } from './FundCompositionPieChart.hooks';

export const FundCompositionPieChart: FC = () => {
  const { data } = useGetFundDetailsData({
    enabled: false,
  });

  const { items } = useFundCompositionPieChartHandler();

  const title = `نمودار ترکیب دارایی صندوق ${data?.title}`;

  return (
    <PieChartExtended
      centeredText="ترکیب دارایی"
      classNames={{
        legendValue: 'max-xs:!w-[90px]',
      }}
      items={items}
      title={title}
    />
  );
};
